import _ from 'lodash';

export function formatMoney(value?: number | null) {
    if (value === undefined || value === null || !isFinite(value)) {
        return '0';
    }
    const precision = Number.isInteger(value) ? 0 : 2;
    const [integer, decimals] = value.toFixed(precision).split('.');
    return parseInt(integer).toLocaleString() + (decimals ? `.${decimals}` : '');
}

const ordinalRules = new Intl.PluralRules('en', { type: 'ordinal' });
const ordinalSuffixes: Record<string, string> = {
    one: 'st',
    two: 'nd',
    few: 'rd',
    other: 'th',
};
export function getOrdinal(value: number) {
    const category = ordinalRules.select(value);
    const suffix = ordinalSuffixes[category];
    return `${value}${suffix}`;
}

export function getPercentage(value?: number | null) {
    if (value === undefined || value === null) {
        return 0;
    }
    return _.round(value * 100, 1);
}
